// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2pkkv","question":"Question_question__1SLbw","description":"Question_description__3ch3v"};